import { useMemo } from 'react';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useProjectTemplates } from 'queries';
import { getRandomColor } from 'utils/get-random-color';
import { groupOptionsByFolder, isFolderGrouped } from 'utils/templates/template-folder-grouping';
export const useTemplateField = (fieldId)=>{
    const { data: templates = [] } = useProjectTemplates();
    const fieldLabel = useTranslation('project.fields.template');
    const unassignedLabel = useTranslation('templates.folders.unassigned');
    return useMemo(()=>{
        const options = templates.map((x)=>{
            var _x_templateName;
            return {
                label: (_x_templateName = x.templateName) !== null && _x_templateName !== void 0 ? _x_templateName : '',
                value: x.templateId,
                color: getRandomColor(x.templateId),
                active: true,
                folderId: x.folderId,
                folderName: x.folderName
            };
        });
        const groupedOptions = groupOptionsByFolder(options, unassignedLabel);
        const groups = isFolderGrouped(groupedOptions) ? groupedOptions.map((group)=>({
                id: group.folderId,
                label: group.label,
                optionValues: group.options.map((option)=>option.value)
            })) : [];
        return {
            templateField: {
                type: FieldType.MultiSelect,
                customField: false,
                fieldId,
                fieldName: 'template',
                fieldLabel,
                metaData: {
                    options,
                    groups
                },
                private: true,
                sourceType: SourceType.Project
            },
            isLoading: false
        };
    }, [
        fieldId,
        fieldLabel,
        templates,
        unassignedLabel
    ]);
};
